@if (item(); as item) {
    <button
        (click)="select.emit()"
        class="p-4 px-5 flex flex-col gap-2 border rounded-xl w-full transition-colors hover:bg-[#F4FAFD]"
    >
        <div class="flex justify-between w-full items-center">
            <div class="flex gap-2 items-center">
                @if (item.voucher) {
                    <app-badge variant="outline">바우처</app-badge>
                } @else {
                    <app-badge variant="outline" color="gray">일반</app-badge>
                }
                <p class="text-gray-600 text-sm">{{ item.name }}</p>
            </div>
            <app-icon
                name="material-symbols:arrow-forward-ios"
                class="text-gray-400 !size-3"
            />
        </div>
        <div class="flex w-full items-center justify-between">
            <p class="text-gray-400 text-sm text-left">
                @if (item.startAt) {
                    {{ item.startAt | date: "y.MM.dd" }} ~
                    {{ item.endAt | date: "y.MM.dd" }}
                } @else {
                    -
                }
            </p>

            @if (item?.enrollment?.teacher; as teacher) {
                <div class="flex gap-2 items-center">
                    <div
                        class="rounded-full size-2"
                        [style.backgroundColor]="teacher?.color"
                    ></div>
                    <p class="font-normal text-gray-700 text-sm">
                        {{ teacher.username }}
                    </p>
                </div>
            }
        </div>
    </button>
}
